import type { JSX } from 'react';

import { Loader2 } from 'lucide-react';

const ActivityLoadingState = (): JSX.Element => (
  <div className="flex items-center gap-2 py-10 text-sm text-text-muted font-body">
    <Loader2 className="size-4 shrink-0 animate-spin" aria-hidden />
    Cargando actividad…
  </div>
);

export default ActivityLoadingState;
